import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

import Header from "../Header";
import Footer from "../Footer";
import { fetchAllApprovedPosts } from "../../utils/PostComponents";
import {
  clearAllFilters,
  handleFilterChange,
  handleSearchChange,
  removeFilter,
} from "../../utils/Filter";
import { truncateDescription } from "../../utils/truncateDescritopn";

const Base_Url = process.env.REACT_APP_BASE_URL;
const AllApprovedPosts = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page")) || 1;

  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  const [filters, setFilters] = useState({
    sort: "",
    search: "",
  });
  const [activeFilters, setActiveFilters] = useState({
    sort: "",
    search: "",
  });

  const updateUrlParams = useCallback(
    async (newPage, newLimit) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("page", newPage);
      searchParams.set("limit", newLimit);
      searchParams.set("search", filters.search);
      searchParams.set("sort", filters.sort);
      navigate({ search: searchParams.toString() });
    },
    [location.search, navigate, filters]
  );

  const fetchData = useCallback(async () => {
    const data = await fetchAllApprovedPosts(
      setPosts,
      setTotalPages,
      filters,
      page,
      limit
    );
    let newPage = data.totalPosts > page ? page : 1;
    setPage(newPage);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [filters, page, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    updateUrlParams(page, limit);
  }, [page, limit, updateUrlParams]);

  const handleViewPost = (post) => {
    navigate(`/view/post/${post._id}`);
  };

  // Pagination calculations
  const handlePageChange = async (selectedPage) => {
    const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    setPage(newPage);
    await updateUrlParams(newPage, limit);
  };

  const handleLimitChange = async (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1);
    await updateUrlParams(1, newLimit);
  };

  return (
    <>
      <div>
        <Header />
        <div className="below-header">
          <p>
            <NavLink to={"/"}>Home</NavLink>
            <span>/</span>
            <a href={location.pathname} className="aCustom">Posts</a>
          </p>
        </div>
        <div className="custom_container">
          <h2 className="heading">Posts</h2>
          {loading && (
            <div className="container loading-dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          )}
          {!loading && (
            <div className="top all_post_filter">
              <div className="filter-container">
                <input
                  type="text"
                  placeholder="Search by title..."
                  value={filters.search}
                  onChange={(e) => {
                    handleSearchChange(
                      e,
                      filters,
                      setFilters,
                      setActiveFilters,
                      activeFilters
                    );
                  }}
                  className="search-bar"
                />
                <select
                  name="sort"
                  value={filters.sort}
                  onChange={(e) => {
                    handleFilterChange(
                      e,
                      filters,
                      setFilters,
                      setActiveFilters
                    );
                  }}
                >
                  <option value="">Default</option>
                  <option value="amountLowToHigh">Amount: Low to High</option>
                  <option value="amountHighToLow">Amount: High to Low</option>
                </select>
              </div>
              <div className="active-filters">
                {Object.keys(activeFilters).map(
                  (key) =>
                    activeFilters[key] && (
                      <div key={key} className="filter-chip">
                        <span>
                          {key.charAt(0).toUpperCase() + key.slice(1)}:{" "}
                          {activeFilters[key]}
                        </span>
                        <button
                          onClick={() =>
                            removeFilter(
                              key,
                              filters,
                              setFilters,
                              setActiveFilters
                            )
                          }
                        >
                          X
                        </button>
                      </div>
                    )
                )}
                {Object.values(activeFilters).some((filter) => filter) && (
                  <button
                    onClick={() => {
                      clearAllFilters(setFilters, setActiveFilters);
                    }}
                    className="clear-all-button"
                  >
                    Clear All
                  </button>
                )}
              </div>
            </div>
          )}
          {!loading &&
            (posts && posts.length > 0 ? (
              <div className="post-container">
                {posts.map((post) => (
                  <div
                    className="post-card"
                    key={post._id}
                    onClick={() => {
                      handleViewPost(post);
                    }}
                  >
                    <div className="card-image">
                      <img
                        src={`${Base_Url}/assets/postThumbnails/${post.attachment}`}
                        alt="Post Img"
                      />
                    </div>
                    <div className="card-content">
                      <h3 className="post-title">{post.title}</h3>
                      <p className="amount">Total Amount : ${post.amount}</p>
                      <p className="amount">
                        Total Paid : ${post.paidAmount ? post.paidAmount : 0}
                      </p>
                      <p
                        className="description"
                        dangerouslySetInnerHTML={{
                          __html: truncateDescription(post.description, 30),
                        }}
                      ></p>
                      <div className="view_post">
                        <button
                          className="donate-btn"
                          onClick={() => {
                            handleViewPost(post);
                          }}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="post-container">No Posts Found</div>
            ))}
          {!loading && (
            <div className="blog-paginate">
              <div className="limit-selection">
                <label htmlFor="limit">Posts per page: </label>
                <select id="limit" value={limit} onChange={handleLimitChange}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={35}>35</option>
                  <option value={50}>50</option>
                </select>
              </div>
              {posts && posts.length > 0 && totalPages && totalPages > 1 && (
                <ReactPaginate
                  pageCount={totalPages}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  pageClassName={"page-item"}
                  activeClassName={"active"}
                  forcePage={page - 1} // Sync with current page
                />
              )}
            </div>
          )}{" "}
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AllApprovedPosts;
